// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { createContext } from "react";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// The Firebase config object contains unique, but non-secret identifiers for your Firebase project and app.
const firebaseConfig = {
    apiKey: "AIzaSyAl65dY2rn0eLXYsJEmZXKX3ljQZxQrcWc",
    authDomain: "project-166e740a-11d4-41b5-9cd.firebaseapp.com",
    projectId: "project-166e740a-11d4-41b5-9cd",
    storageBucket: "project-166e740a-11d4-41b5-9cd.firebasestorage.app",
    messagingSenderId: "914922096478",
    appId: "1:914922096478:web:c1a31862f0578b78da31cf",
    measurementId: "G-SP4M4L5M4X",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
if (import.meta.env.DEV) {
    auth.settings.appVerificationDisabledForTesting = true;
}

// Functions
export const AuthContext = createContext();
